import React, { useEffect, useRef, useState } from "react";
import { request } from "../../../functions/request";
import {
  Button,
  DatePicker,
  Descriptions,
  Form,
  Input,
  message,
  Select,
  Tooltip,
} from "antd";
import {
  updateData,
  estadosOptions,
  verificarVariacaoValor,
} from "../../../functions/functionsUtility";
import { FaSave } from "react-icons/fa";
import dayjs from "dayjs";

const milhoOptions = [
  { value: "mil_compr_mn", label: "Mínima:", span: 3 },
  { value: "mil_compr_mx", label: "Máxima:", span: 3 },
];

export default function IntergraosMilhoCotacao() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [uf, setUf] = useState(null);
  const [date, setDate] = useState(dayjs().format("DD/MM/YYYY"));
  // Snapshot imutável do valor carregado da API, pra comparar contra o que
  // o usuário digita (cotacoesData já vai sendo sobrescrito a cada tecla).
  const baselineRef = useRef({});
  // Campos com valor fora do padrão (10% de variação) — além do toast,
  // marca o input com borda de alerta + tooltip explicando o motivo,
  // já que o toast some sozinho depois de alguns segundos.
  const [camposComAlerta, setCamposComAlerta] = useState({});

  const onChange = (_, dateString) => {
    setDate(dateString);
  };

  async function getData(values) {
    setIsLoading(true);
    const currentPathWithQuery = `/milho_cotacao/getMilhoCotacao?uf=${
      values.uf
    }&data=${encodeURIComponent(values.date)}`;
    const response = await request(currentPathWithQuery, {
      method: "GET",
    }).catch((reason) => {
      console.log(reason);
      setCotacoesData("");
    });
    console.log(response);
    // Praça sem cotação nesta data (ex.: mercado novo, como PA): formulário
    // em branco para a UF e o dia escolhidos — a API cria a linha ao salvar.
    const linha = Array.isArray(response) ? response[0] : undefined;
    const data = {
      ...(linha || {
        mil_uf: values.uf,
        mil_data: dayjs(values.date, "DD/MM/YYYY").format("YYYY-MM-DD"),
        mil_compr_mn: "",
        mil_compr_mx: "",
        semCotacao: true,
      }),
      endpoint: "updateMilhoCotacao",
      path: "milho_cotacao",
    };

    Object.keys(data).forEach((el, index) => {
      if (typeof data[el] === "number") {
        data[el] = data[el].toFixed(2);
        data[el] = data[el].toString().replace(".", ",");
      }
    });
    setCotacoesData(data);
    baselineRef.current = data;
    setCamposComAlerta({});
    setIsLoading(false);
  }

  useEffect(() => {
    if (uf && date) getData({ uf, date });
  }, [uf, date]);

  console.log(cotacoesData)

  return (
    <Form>
      <Descriptions
        title={"Intergrãos - Milho - Cotação"}
        bordered
        extra={
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            icon={<FaSave />}
            disabled={isLoading}
            onClick={() => {
              console.log(cotacoesData);
              if (cotacoesData?.semCotacao && milhoOptions.some((o) => !cotacoesData[o.value])) {
                message.warning("Preencha as cotações mínima e máxima para criar a primeira cotação desta praça.");
                return;
              }
              updateData(cotacoesData);
            }}
          >
            Atualizar
          </Button>
        }
        style={{ padding: 10 }}
      >
        <Descriptions.Item
          label={"Estado"}
          span={2}
          children={
            <Select
              style={{ width: "100%", marginTop: "10px" }}
              onChange={(value) => {
                setCotacoesData({ ...cotacoesData, mil_uf: value });
                setUf(value);
              }}
              placeholder="Selecione o estado"
            >
              {estadosOptions.map((el, index) => {
                return (
                  <Select.Option key={index} value={el.value}>
                    {el.label}
                  </Select.Option>
                );
              })}
            </Select>
          }
        />
        <Descriptions.Item
          label={"Data"}
          span={1}
          children={
            <DatePicker
              defaultValue={dayjs()}
              format={"DD/MM/YYYY"}
              onChange={onChange}
            />
          }
        />
        <Descriptions.Item
          label={"Última Alteração"}
          span={3}
          children={
            cotacoesData?.semCotacao
              ? "Sem cotação nesta data — será criada ao salvar"
              : dayjs(cotacoesData?.mil_data, "YYYY-MM-DDTHH:mm:ss.zzz").format("DD/MM/YYYY [às] HH:mm")
          }
        />
        {!isLoading &&
          milhoOptions.map((element) => (
            <Descriptions.Item
              label={element.label}
              span={element.span}
              children={
                <Tooltip
                  title={camposComAlerta[element.value]?.mensagem}
                  open={!!camposComAlerta[element.value]}
                  color="orange"
                >
                  <Input
                    datatype=""
                    status={camposComAlerta[element.value] ? "warning" : ""}
                    value={cotacoesData[element.value]}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const formattedValue = inputValue.trim();
                      const newData = {
                        ...cotacoesData,
                        [element.value]: formattedValue,
                      };
                      setCotacoesData(newData);
                    }}
                    onBlur={() => {
                      const alerta = verificarVariacaoValor(
                        cotacoesData[element.value],
                        baselineRef.current[element.value],
                        element.label
                      );
                      setCamposComAlerta((prev) => ({
                        ...prev,
                        [element.value]: alerta,
                      }));
                    }}
                  />
                </Tooltip>
              }
            />
          ))}
      </Descriptions>
    </Form>
  );
}
